import React from 'react';
import './index.css';

class OurDriver extends React.Component {
  handlerClosePopup = () => {
    this.props.toClose();
  }
  render(){
    return (
      <div className={this.props.showDriver ? "our-drivers" : "our-drivers__hide"}>
          <h4 className="our-drivers__title">Our drivers have performance experience <div onClick={this.handlerClosePopup} className="our-driver__cross">+</div></h4>
          <p className="our-drivers__text">
              All of our dirvers are carfully selected and 
              have extensive performance driving experience. Giving them 
              the ability to deal with any situation professionally and safely. 
              Their code of conduct is for maximum experience. These attributes are 
              determined by the driver and experience type you provide. The journey and 
              contact with the client is conducted according to a carefully established 
              procol with an emphasis on detail. 
          </p>
          <a href="#link__drivers" className="our-drivers__link">drivers</a>
      </div>
    );
  }
}

export default OurDriver;
